<template>
	<a 
		:href="url"
		:target="target"
		:rel="rel"
		class="v-resume-link"
		:class="[
			{ 'v-resume-link--large': large }
		]">
		<span ref="vresume_link">{{ text }}</span>
	</a>
</template>
<script>
export default {
	props: {
		newWindow: Boolean,
		large: Boolean,
		text: String,
		url: String
	},
	computed: {
		target() {
			return this.newWindow ? '_blank': '_self'
		},
		rel() {
			return this.newWindow ? 'noopener nofollow noreferrer' : ''
		}
	}
}
</script>
<style lang="scss" scoped>
.v-resume-link {
	text-decoration: none;
	font-size: 15px;
	line-height: 20px;
	font-weight: 500;
	background: transparent;
	background: linear-gradient(278deg, #848BD3 0%, #BC89E5 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	& span {
		background: linear-gradient(278deg, #848BD3 0%, #BC89E5 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	&--large {
		font-size: 20px;
		line-height: 28px;
	}
}
</style>